import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return inst;
  }, [getToken]);
}

export const errMsg = (e, fallback = "Something went wrong. Please try again.") =>
  (typeof e?.response?.data?.detail === "string" && e.response.data.detail) || fallback;

export function startPlanPath(me) {
  if (!me) return "/";
  if (!me.plans_open && me.role !== "admin" && !(me.tester && me.plans_created < 1)) return "/not-yet";
  if (!me.is_member && me.role !== "admin" && me.plans_created >= 1 && !me.bonus_plans) return "/membership";
  if ((me.is_member || me.role === "admin") && me.stats?.active_plans >= 3) return "/plans?limit=1";
  if (!me.baskets) return "/baskets";
  return "/ready";
}

export function formatDate(iso, opts = { day: "numeric", month: "long", year: "numeric" }) {
  if (!iso) return "";
  const d = iso.length === 10 ? new Date(`${iso}T12:00:00`) : new Date(iso);
  return d.toLocaleDateString("en-NZ", opts);
}
